module.exports = __webpack_public_path__ + "img/pen-slash.31fb5a00.svg";